import React, {useEffect, useRef} from "react";
import gsap from "gsap";

import styles from "./ImageText.module.scss";
import Image from "../Global/Image";
import isMobile from "ismobilejs";

export default function ImageText ({image, classname = null, radius, align, children}) {
    const article = useRef(null);

    useEffect(() => {
        const imageMobile = article.current.querySelector('[data-image-mobile]');

        if (imageMobile && isMobile().phone) {
            const image = article.current.getElementsByTagName('figure')[0];

           imageMobile.appendChild(image);
        }
    }, []);

    useEffect(() => {
        const vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);

        if (classname) {
            if (classname.indexOf('image-out') > -1 && (!isMobile().phone || window.outerWidth > 800)) {
                const image = article.current.querySelector('figure');

                window.addEventListener('scroll', () => {
                    const articleRect = article.current.getBoundingClientRect();
                    const articleBottom = vh - articleRect.bottom;

                    if (articleBottom > 0 && articleRect.bottom > 0) {
                        gsap.set(image, {
                            y: articleBottom * .2
                        })
                    }
                }, {passive: true})
            }
        }
    }, [classname]);

    return (
        <article className={[styles.Main, classname ?? ''].join(' ')} ref={article} style={{alignItems: align}}>
            <Image src={image.src} srcRet={image.srcRet} webp={image.webp} webpRet={image.webpRet} alt={children} radius={radius}/>

            <div>
                {children}
            </div>
        </article>
    )
}
